import React, { useEffect, useState, useRef } from 'react';
import GoUpBtn from '../../common/GoUpBtn';
import GoUpParag from '../../common/GoUpParag';
import Legend from '../../common/Legend';
import PrematchContext from '../../contexts/PrematchContext';
import PrematchHomeContext from '../../contexts/PrematchHomeContext';
import { parseMacroGruppi } from '../../data/parseMacroGruppi';
import { getConfiguration } from '../../data/utils';
import { useLayout, useUISettings, useUISettingsDispatch } from '../../UISettingsProvider';
import PrematchHomeContentWrapper from './PrematchHomeContentWrapper';
import PrematchHomeMatch from './PrematchHomeMatch';
import PrematchTournamentsList from './PrematchTournamentsList';

function PrematchHome(props) {
    const conf = getConfiguration();
    const uiSettings = useUISettings();
    const prematchContext = React.useContext(PrematchContext);
    const dispatch = useUISettingsDispatch();
    const layout = useLayout();
   
    const [state, setState] = useState({
        forceReload: false,
        match: null,
        betBuilderMatch : null,
        isLiveMatch: false,

        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        changeMatch: function(match, isLiveMatch = false) {
            match.macrogruppi = parseMacroGruppi(match.gruppoById, match.sportRef, match.isLive);
            this.update({
                match,
                isLiveMatch,
                betBuilderMatch : null
            });
        },
        openMatchBetBuilder: function(betBuilderMatch, openChooseSection){
        	if(!betBuilderMatch){
        		betBuilderMatch = {};
        	}
        	betBuilderMatch.openChooseSection = openChooseSection;
        	betBuilderMatch.betBuilder = true;
        	
        	this.update({
                betBuilderMatch,
                match:null,
                isLive:false
            });
        },
        reloadTournaments: function() {
            this.update({forceReload: !this.forceReload});
        },
    });

    // Quando viene passato un match diretto come prop
    // aggiorno il context così che venga aperto in sostituzione del corrente
    useEffect(function() {
        if (props.match != null) {
            state.changeMatch(props.match);
        }
    }, [props.match]);

	
    /* Workaround: uiSettings.fullScreen dovrebbe essere inizializzato in base a conf.stf.
       Dato che però uiSettingsCOntext è utilizzato dentro Main.js prima di chiamare InitData,
       quando il local storage è vuoto, conf è null.
    */
   const firstRender = useRef(true);
    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            dispatch({
                type: 'setFullscreen',
                isFullScreen: (conf?.tfs === true || conf?.sctc === true || prematchContext.match?.openedFromBanner) && !props.openFromPath?.match
            });
        }
    });

    const selectedTournaments = props.selectedTournaments;
    const match = state.betBuilderMatch ? state.betBuilderMatch : state.match;
	
    return (
        <PrematchHomeContext.Provider value={state}>
            <div className={"griglia-centrale-sport col stringimento-sidebar " + layout.order.divCentrale} id="div-centrale">
                <div className="contenitore-schedine-sport">
                  
                        <>
                            {selectedTournaments.length > 0 && 
                                <PrematchHomeContentWrapper>
                                    <>
                                        <GoUpBtn />
                                        <PrematchTournamentsList data={props.data} selectedTournaments={selectedTournaments} forceReload={state.forceReload} openFromPath={props.openFromPath} />
                                        <GoUpParag/>
                                        <Legend />
                                    </>
                                    <PrematchHomeMatch match={match} isLive={state.isLiveMatch} />
                                </PrematchHomeContentWrapper>
                            }
                        </>

                    
                </div>
            </div>
        </PrematchHomeContext.Provider>
    );
}

export default PrematchHome;